import { SERVER } from "../environment.constants";

export class BookmarkUrl {
    private static bookmark: string = SERVER + "/bookmark";
    public static add: string = BookmarkUrl.bookmark + "/add";
    public static get: any = (accountSeq: number) => `${BookmarkUrl.bookmark}/${accountSeq}`;
    public static delete: any = (bookmarkSeq: number) => `${BookmarkUrl.bookmark}/${bookmarkSeq}`;
    public static deleteAll: any = (accountSeq: number) => `${BookmarkUrl.bookmark}/${accountSeq}/all`;
}